
import React from 'react';
import { IconProps } from '../../types/types';

const LeftArrow: React.FC<IconProps> = ({ color = '#595959' }) => (
    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.55117 9.84037L1.82746 6.11265C1.38769 5.67242 1.38808 4.95242 1.82832 4.51265L5.55603 0.78894" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default LeftArrow;